import React, { useEffect, useMemo, useState } from "react";

export interface CountdownProps {
  initialMs: number;
  refreshMs?: number;
  /**
   * Formateador opcional; recibe segundos restantes (entero >= 0)
   * y devuelve el texto a renderizar.
   */
  formatter?: (seconds: number) => string;
}

const defaultFormatter = (seconds: number) => {
  const label = seconds === 1 ? "segundo" : "segundos";
  return `~${seconds} ${label}`;
};

export const Countdown: React.FC<CountdownProps> = ({ initialMs, refreshMs = 1000, formatter = defaultFormatter }) => {
  const deadline = useMemo(() => Date.now() + Math.max(0, initialMs), [initialMs]);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), Math.max(100, refreshMs));
    return () => window.clearInterval(id);
  }, [refreshMs]);

  const remainingMs = Math.max(0, deadline - now);
  const remainingSeconds = Math.ceil(remainingMs / 1000);

  return <span>{formatter(remainingSeconds)}</span>;
};

export default Countdown;

